<template>
    <b-form
        :save-url="addUrl"
        @success="formSuccess"
        @failure="formFailure"
        v-slot="{ model, loading }"
        :save-params="{ api_key: currentUser.api_key }"
    >

        <div class="row">
            <validated-input
                class="col-6"
                label="Partner Name"
                v-model="model.name"
                :rules="{
                    required: true,
                    max: 25
                }"
                :disabled="loading"
            />

            <div class="file-upload-wrapper col-6">
                <label class="field-label">Logo</label>

                <div
                    class="custom-file-input"
                    @click="triggerFileInput(loading)"
                >
                    <span>{{ model.logo ? model.logo.name : 'Browse' }}</span>
                </div>

                <input
                    ref="fileInput"
                    type="file"
                    class="hidden-file-input"
                    accept="image/*"
                    :disabled="loading"
                    @change="handleFileChange($event, model)"
                />
            </div>
        </div>

        <div class="row">
            <div class="col">
                <image-info :width="327" :height="220"/>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <validated-textarea
                    label="Description"
                    v-model="model.description"
                    :rules="rules.description"
                    :disabled="loading"
                />
            </div>
        </div>

        <div class="row">
            <validated-input
                class="col-6"
                label="Website link"
                v-model="model.website_link"
                :rules="rules.website_link"
                :disabled="loading"
            />

            <checkbox-input
                class="col-6"
                label="Disable"
                v-model="model.disabled"
                :rules="rules.disabled"
                :disabled="loading"
            />
        </div>

        <btn
            class="trn"
            size="sm"
            :loading="loading"
            color="primary"
            text="Save"
            loading-text="Saving..."
            :disabled="loading"
        />
    </b-form>
</template>

<script>
import urls from '../../../data/urls';
import { mapGetters } from 'vuex';

export default {
    name : 'AddPartner',

    computed : {
        ...mapGetters(['currentUser'])
    },

    data () {
        return {
            addUrl : urls.admin.partner.addEdit,

            rules : {
                description : {
                    required : true,
                    max      : 240
                },

                logo : {
                    required : true
                },

                website_link : {
                    required : true
                },

                disabled : {
                    required : false
                }
            }
        };
    },

    methods : {

        triggerFileInput (loading) {
            if (!loading) {
                this.$refs.fileInput.click();
            }
        },

        handleFileChange (event, model) {
            const file = event.target.files && event.target.files[0];

            if (!file) {
                return;
            }

            const image = new Image();

            image.onload = () => {
                URL.revokeObjectURL(image.src);

                if (image.width !== 327 || image.height !== 220) {
                    this.$notify(
                        'Please upload an image with dimensions 327 × 220 pixels.',
                        'Invalid Image',
                        {
                            type : 'warning'
                        }
                    );

                    // Clear input
                    event.target.value = '';

                    // Clear model
                    this.$set(model, 'logo', null);

                    return;
                }

                // Valid image
                this.$set(model, 'logo', file);
            };

            image.onerror = () => {
                URL.revokeObjectURL(image.src);

                this.$notify(
                    'Unable to read the selected image.',
                    'Invalid Image',
                    {
                        type : 'warning'
                    }
                );

                event.target.value = '';
                this.$set(model, 'logo', null);
            };

            image.src = URL.createObjectURL(file);
        },

        formSuccess () {
            this.$notify(
                'Successfully Added Partner..!',
                'Success',
                {
                    type : 'success'
                }
            );

            this.$emit('success');
        },

        formFailure (response) {
            const json = response.data;

            if (json.permission === false) {
                this.$notify(
                    'Invalid Authentication..!',
                    'Permission Denied',
                    {
                        type : 'warning'
                    }
                );
                return;
            }

            if (json.errors) {
                Object.entries(json.errors).forEach(([field, message]) => {
                    this.$notify(
                        `${field}: ${message}`,
                        'Validation Error',
                        {
                            type : 'warning'
                        }
                    );
                });

                return;
            }

            this.$notify(
                'Something went wrong!',
                'Error',
                {
                    type : 'error'
                }
            );
        }
    }
};
</script>

<style scoped>
.hidden-file-input {
    display: none;
}

.custom-file-input {
    width: 100%;
    height: 38px;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    padding: 8px 10px;
    font-size: 14px;
    line-height: 1.5;
    display: flex;
    align-items: center;
    background-color: white;
    cursor: pointer;
    color: black;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
</style>
